import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dialog, DialogActions, } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from './DialogTitle';
import ColoredButton from '../button/ColoredButton';
const renderButtons = (buttons) => buttons.map((coloredButtonProps, index) => (_jsx(ColoredButton, Object.assign({ fullWidth: true, variant: "contained" }, coloredButtonProps), `base-dialog-button-${index}`)));
const BaseDialog = forwardRef((props, ref) => {
    const { title, open, onClose, children, buttons, fullWidth = false, fullScreen = false, headerButtonsLeft, headerButtonsRight, showCloseButton = true, className, } = props;
    const closeDialog = () => {
        onClose(false);
    };
    return (_jsxs(Dialog, { ref: ref, open: open, onClose: closeDialog, fullWidth: fullWidth, fullScreen: fullScreen, disableEnforceFocus: fullScreen, className: className, children: [_jsx(DialogTitle, { title: title, onClose: closeDialog, headerButtonsLeft: headerButtonsLeft, headerButtonsRight: headerButtonsRight, showCloseButton: showCloseButton }), _jsx(DialogContent, { children: children }), _jsx(DialogActions, { children: renderButtons(buttons || []) })] }));
});
export default BaseDialog;
